import Model from 'models/Model';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import ProductEnhancementDocument from 'models/productManagement/productEnhancementDocument/ProductEnhancementDocument';
import { Language } from 'assets/locales/Locale';

export default class ProductEnhancementDealerDocument
  extends Model<Model.IProductEnhancementDealerDocument>({ icon: 'if-login' })
  implements Model.Instance<Model.IProductEnhancementDealerDocument>
{
  id: number;
  productEnhancementDocumentId: number;
  productEnhancementDocument?: ProductEnhancementDocument;
  dealerId: number;
  mediaFileId: number;
  mediaFile: MediaFile;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data: Partial<Model.IProductDealerDocument> | Utils.FormData<Model.IProductDealerDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        productEnhancementDocument: ProductEnhancementDocument,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id?.toString(),
    };
  }
}
